const socialLinks = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/tobyccw/' },
  { label: 'Email',    href: 'mailto:tobyccw@gmail.com' },
  { label: 'Are.na',  href: 'https://www.are.na/toby-c/channels' },
];

export default socialLinks;
